import { useGetDocument } from '@modusign/openapi-client-external-document';
import { useDispatch } from 'react-redux';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { useInvalidateDocumentList } from '@app/routes/Documents/useDocumentList';
import { unBlockDocument } from '@app/store/documents/actions';
import { modalClose } from '@app/store/modal/actions';

interface DocumentUnBlockModalComponentProps {
  documentId: string;
}

export default function DocumentUnBlockModalComponent({
  documentId,
}: DocumentUnBlockModalComponentProps) {
  const workspaceId = useWorkspaceId();
  const dispatch = useDispatch();
  const invalidate = useInvalidateDocumentList();

  const { refetch } = useGetDocument(workspaceId, documentId);

  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop box-6x align-center">
        <h4 className="space-3x">
          <strong>차단 해제</strong>
        </h4>
        <p className="space-4x">
          차단을 해제하면
          <br />
          모든 서명자들이 문서를 확인할 수 있습니다.
        </p>
        <div>
          <div>
            <button
              className="Btn"
              type="button"
              onClick={() => {
                dispatch(modalClose());
              }}
            >
              취소
            </button>
            <button
              className="Btn Btn--primary"
              type="submit"
              onClick={() => {
                dispatch(modalClose());
                dispatch(unBlockDocument({ documentId, invalidate }));
                refetch();
              }}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
